export const LOCALE_STORAGE_KEY = 'fm_locale';
export const LOCALE_LABELS = {
    en: 'English',
    es: 'Español',
};
export const SUPPORTED_LOCALES = Object.keys(LOCALE_LABELS);
export function isSupportedLocale(value) {
    return value in LOCALE_LABELS;
}
export function readStoredLocale() {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        const raw = window.localStorage.getItem(LOCALE_STORAGE_KEY);
        if (raw && isSupportedLocale(raw)) {
            return raw;
        }
    }
    catch {
        // ignore private mode / blocked storage
    }
    return null;
}
export function persistLocale(locale) {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
    }
    catch {
        // ignore
    }
}
export function applyDocumentLocale(locale) {
    if (typeof document === 'undefined') {
        return;
    }
    document.documentElement.lang = locale;
}
//# sourceMappingURL=locale-config.js.map